import { combineReducers } from '@reduxjs/toolkit';
import { reducer as appDataReducer } from './reducers/appData';

const rootReducer = combineReducers({
  appData: appDataReducer
});

export default rootReducer;
